import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FollowUpService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  createFollowUp(cqNumber: string, payload: any) {

    return this.http.post(
      `${environment.BASE_URL}/followUp`,
      payload,
      this.httpOptions
    );
  }
}
